(function () {
  function initFileUploads() {
    document.querySelectorAll('.custom-field--file').forEach((wrapper) => {
      const fileInput = wrapper.querySelector('.custom-field__file-input');
      const fileNameEl = wrapper.querySelector('.custom-field__file-name');
      const hiddenProperty = wrapper.querySelector('.custom-field__file-property');
      const errorEl = wrapper.querySelector('.custom-field__error');
      if (!fileInput) return;

      fileInput.addEventListener('change', () => {
        const file = fileInput.files[0];
        errorEl.hidden = true;
        errorEl.textContent = '';

        if (!file) {
          fileNameEl.textContent = 'No file chosen';
          fileNameEl.classList.remove('custom-field__file-name--selected');
          if (hiddenProperty) hiddenProperty.value = '';
          return;
        }

        const maxMb = parseFloat(fileInput.dataset.maxMb) || 10;
        const maxBytes = maxMb * 1024 * 1024;

        if (file.size > maxBytes) {
          errorEl.textContent = `File is too large. Maximum size is ${maxMb} MB.`;
          errorEl.hidden = false;
          fileInput.value = '';
          fileNameEl.textContent = 'No file chosen';
          fileNameEl.classList.remove('custom-field__file-name--selected');
          if (hiddenProperty) hiddenProperty.value = '';
          return;
        }

        fileNameEl.textContent = file.name;
        fileNameEl.classList.add('custom-field__file-name--selected');
        // Store the filename as the line item property value so it appears on the order
        if (hiddenProperty) hiddenProperty.value = file.name;
      });
    });
  }

  function validateCustomFields(form) {
    let valid = true;
    // Validate required file uploads
    form.querySelectorAll('.custom-field__file-property[data-required="true"]').forEach((hidden) => {
      const wrapper = hidden.closest('.custom-field--file');
      const errorEl = wrapper?.querySelector('.custom-field__error');
      if (!hidden.value) {
        valid = false;
        if (errorEl) {
          errorEl.textContent = 'Please upload a file.';
          errorEl.hidden = false;
        }
      }
    });
    return valid;
  }

  function bindFormValidation() {
    document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        if (!validateCustomFields(form)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initFileUploads();
      bindFormValidation();
    });
  } else {
    initFileUploads();
    bindFormValidation();
  }
})();
